import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useBodyClassName from 'hooks/useBodyClassName';

import { Spinner } from 'components/core/Spinner';

import './LoadingMask.scss';

export default function LoadingMask({ message, modal, relative }) {
	useBodyClassName(relative ? '' : 'no-scroll');

	const content = (
		<div className={classnames('loading-mask', { relative })}>
			<Spinner loadingMessage={message} />
		</div>
	);

	return modal
		? createPortal(content, document.getElementById('js-modal-content'))
		: content;
}

LoadingMask.propTypes = {
	message: PropTypes.string,
	modal: PropTypes.bool,
	relative: PropTypes.bool,
};
